import { FC, ReactElement } from 'react'

import { InactiveScreen, Page } from '@/containers'
import { localStorageApiTokenKey } from '@/helpers/authorizedFetch'
import { useLocalStorage } from '@/helpers/hooks/useLocalStorage'
import { isOptionalString } from '@/helpers/string'
import { logout } from '@/redux/user/userReducer'
import { useTypedDispatch } from '@/store'

export const ConnectedInactiveScreen: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const [, storeApiToken] = useLocalStorage(localStorageApiTokenKey, undefined, isOptionalString)

    const handleLogOutButtonClick = (): void => {
        storeApiToken(undefined)
        dispatch(logout())
    }

    return (
        <Page showLanguageSelector>
            <InactiveScreen onLogOutButtonClick={handleLogOutButtonClick} />
        </Page>
    )
}
